const otherSportTags = [
  {
    title: "other wow",
    id: "other_wow",
  },
];
const generalTags = [
  {
    title: "bad",
    id: "general_bad",
  },
  {
    title: "good",
    id: "general_good",
  },
  {
    title: "drill",
    id: "general_drill",
  },
];

const basketballTags = [
  {
    title: "dunk",
    id: "basketball_dunk",
  },
  {
    title: "three point",
    id: "basketball_three_point",
  },
  {
    title: "big play",
    id: "basketball_big_play",
  },
  {
    title: "alley oop",
    id: "basketball_alley_oop",
  },
  {
    title: "assist",
    id: "basketball_assist",
  },
  {
    title: "block",
    id: "basketball_block",
  },
  {
    title: "momentum",
    id: "basketball_momentym",
  },
  {
    title: "money time",
    id: "basketball_money_time",
  },
  {
    title: "substitution",
    id: "basketball_substitution",
  },
];

const soccerTags = [
  {
    title: "goal",
    id: "soccer_goal",
  },
  {
    title: "penalty",
    id: "soccer_penalty",
  },
  {
    title: "shot on target",
    id: "soccer_shot_on_target",
  },
  {
    title: "yellow card",
    id: "soccer_yellowcard",
  },
  {
    title: "red card",
    id: "soccer_redcard",
  },
  {
    title: "foul",
    id: "soccer_foul",
  },
  {
    title: "corner kick",
    id: "soccer_corner_kick",
  },
  {
    title: "shot",
    id: "soccer_shot",
  },
  {
    title: "free kick",
    id: "soccer_free_kick",
  },
  {
    title: "header",
    id: "soccer_header",
  },
  {
    title: "save",
    id: "soccer_save",
  },
  {
    title: "substitution",
    id: "soccer_substitution",
  },
];

const footballTags = [
  {
    title: "touch down",
    id: "football_touch_down",
  },
  {
    title: "field goal",
    id: "football_field_goal",
  },
  {
    title: "big catch",
    id: "football_big_catch",
  },
  {
    title: "big run",
    id: "football_big_run",
  },
  {
    title: "big hit",
    id: "football_big_hit",
  },
  {
    title: "kick return",
    id: "football_kick_return",
  },
  {
    title: "punt return",
    id: "football_punt_return",
  },
  {
    title: "kickoff",
    id: "football_kickoff",
  },
  {
    title: "substitution",
    id: "football_substitution",
  },
];

const rugbyTags = [
  {
    title: "break down",
    id: "rugby_break_down",
  },
  {
    title: "conversion",
    id: "rugby_conversion",
  },
  {
    title: "drop goal",
    id: "rugby_drop_goal",
  },
  {
    title: "garry owen",
    id: "rugby_garry_owen",
  },
  {
    title: "grubber",
    id: "rugby_grubber",
  },
  {
    title: "knock on",
    id: "rugby_knock_on",
  },
  {
    title: "maul",
    id: "rugby_maul",
  },
  {
    title: "penalty try",
    id: "rugby_penalty_try",
  },
  {
    title: "substitution",
    id: "rugby_substitution",
  },
];

const volleyballTags = [
  {
    title: "free ball",
    id: "volleyball_free_ball",
  },
  {
    title: "side out",
    id: "volleyball_side_out",
  },
  {
    title: "spike",
    id: "volleyball_spike",
  },
  {
    title: "dig",
    id: "volleyball_dig",
  },
  {
    title: "double",
    id: "volleyball_double",
  },
  {
    title: "mishit",
    id: "volleyball_mishit",
  },
  {
    title: "shank",
    id: "volleyball_shank",
  },
  {
    title: "serve",
    id: "volleyball_serve",
  },
  {
    title: "set point",
    id: "volleyball_set_point",
  },
  {
    title: "match point",
    id: "volleyball_match_point",
  },
  {
    title: "substitution",
    id: "volleyball_substitution",
  },
];

const baseballTags = [
  {
    title: "stolen base",
    id: "baseball_stolen_base",
  },
  {
    title: "home run",
    id: "baseball_home_run",
  },
  {
    title: "run",
    id: "baseball_run",
  },
  {
    title: "single",
    id: "baseball_single",
  },
  {
    title: "hit",
    id: "baseball_hit",
  },
  {
    title: "double",
    id: "baseball_double",
  },
  {
    title: "tripple",
    id: "baseball_tripple",
  },
  {
    title: "strikeout",
    id: "baseball_strikeout",
  },
  {
    title: "popout",
    id: "baseball_popout",
  },
  {
    title: "ground out",
    id: "baseball_ground_out",
  },
  {
    title: "fly out",
    id: "baseball_fly_out",
  },
  {
    title: "double play",
    id: "baseball_double_play",
  },
  {
    title: "triple play",
    id: "baseball_triple_play",
  },
  {
    title: "walk",
    id: "baseball_walk",
  },
  {
    title: "top 1st",
    id: "baseball_top_1st",
  },
  {
    title: "bottom 1st",
    id: "baseball_bottom_1st",
  },
  {
    title: "top 2nd",
    id: "baseball_top_2nd",
  },
  {
    title: "bottom 2nd",
    id: "baseball_bottom_2nd",
  },
  {
    title: "substitution",
    id: "baseball_substitution",
  },
];

const lacrosseTags = [
  {
    title: "goal",
    id: "lacrosse_goal",
  },
  {
    title: "shot",
    id: "lacrosse_shot",
  },
  {
    title: "save",
    id: "lacrosse_save",
  },
  {
    title: "clear",
    id: "lacrosse_clear",
  },
  {
    title: "man up",
    id: "lacrosse_man_up",
  },
  {
    title: "penalty",
    id: "lacrosse_penalty",
  },
  {
    title: "face off",
    id: "lacrosse_face_off",
  },
  {
    title: "ground ball",
    id: "lacrosse_ground_ball",
  },
  {
    title: "substitution",
    id: "lacrosse_substitution",
  },
];

const futsalTags = [
  {
    title: "goal",
    id: "futsal_goal",
  },
  {
    title: "penalty",
    id: "futsal_penalty",
  },
  {
    title: "shot on target",
    id: "futsal_shot_on_target",
  },
  {
    title: "yellow card",
    id: "futsal_yellowcard",
  },
  {
    title: "red card",
    id: "futsal_redcard",
  },
  {
    title: "foul",
    id: "futsal_foul",
  },
  {
    title: "corner kick",
    id: "futsal_corner_kick",
  },
  {
    title: "shot",
    id: "futsal_shot",
  },
  {
    title: "free kick",
    id: "futsal_free_kick",
  },
  {
    title: "header",
    id: "futsal_header",
  },
  {
    title: "save",
    id: "futsal_save",
  },
  {
    title: "substitution",
    id: "futsal_substitution",
  },
];

const beachVolleyballTags = [
  {
    title: "free ball",
    id: "beach_volleyball_free_ball",
  },
  {
    title: "side out",
    id: "beach_volleyball_side_out",
  },
  {
    title: "spike",
    id: "beach_volleyball_spike",
  },
  {
    title: "dig",
    id: "beach_volleyball_dig",
  },
  {
    title: "double",
    id: "beach_volleyball_double",
  },
  {
    title: "mishit",
    id: "beach_volleyball_mishit",
  },
  {
    title: "shank",
    id: "beach_volleyball_shank",
  },
  {
    title: "serve",
    id: "beach_volleyball_serve",
  },
  {
    title: "set point",
    id: "beach_volleyball_set_point",
  },
  {
    title: "match point",
    id: "beach_volleyball_match_point",
  },
  {
    title: "substitution",
    id: "beach_volleyball_substitution",
  },
];

const fieldHockeyTags = [
  {
    title: "goal",
    id: "field_hockey_goal",
  },
  {
    title: "penalty corner",
    id: "field_penalty_corner",
  },
  {
    title: "ball possesion",
    id: "field_ball_possesion",
  },
  {
    title: "ball loss",
    id: "field_ball_loss",
  },
  {
    title: "turn over",
    id: "field_turn_over",
  },
  {
    title: "circle penetration",
    id: "field_circle_penetration",
  },
  {
    title: "press",
    id: "field_press_fp_hc",
  },
  {
    title: "interception",
    id: "field_interception",
  },
  {
    title: "time penalty",
    id: "field_time_penalty",
  },
  {
    title: "fight",
    id: "field_hockey_fight",
  },
  {
    title: "big hit",
    id: "field_hockey_big_hit",
  },
  {
    title: "power play",
    id: "field_hockey_power_play",
  },
  {
    title: "4v4",
    id: "field_hockey_4v4",
  },
  {
    title: "shot",
    id: "field_hockey_shot",
  },
  {
    title: "save",
    id: "field_hockey_save",
  },
  {
    title: "other",
    id: "field_hockey_other",
  },
  {
    title: "substitution",
    id: "field_hockey_substitution",
  },
];

const icehockeyTags = [
  {
    title: "goal",
    id: "hockey_goal",
  },
  {
    title: "fight",
    id: "hockey_fight",
  },
  {
    title: "big hit",
    id: "hockey_big_hit",
  },
  {
    title: "power play",
    id: "hockey_power_play",
  },
  {
    title: "4v4",
    id: "hockey_4v4",
  },
  {
    title: "shot",
    id: "hockey_shot",
  },
  {
    title: "save",
    id: "hockey_save",
  },
  {
    title: "substitution",
    id: "hockey_substitution",
  },
];

const rollerHockeyTags = [
  {
    title: "goal",
    id: "roller_hockey_goal",
  },
  {
    title: "corner",
    id: "roller_penalty_corner",
  },
  {
    title: "ball possesion",
    id: "roller_ball_possesion",
  },
  {
    title: "ball loss",
    id: "roller_ball_loss",
  },
  {
    title: "turn over",
    id: "roller_turn_over",
  },
  {
    title: "circle penetration",
    id: "roller_circle_penetration",
  },
  {
    title: "press",
    id: "roller_press_fp_hc",
  },
  {
    title: "interception",
    id: "roller_interception",
  },
  {
    title: "time penalty",
    id: "roller_time_penalty",
  },
  {
    title: "fight",
    id: "roller_hockey_fight",
  },
  {
    title: "big hit",
    id: "roller_hockey_big_hit",
  },
  {
    title: "power play",
    id: "roller_hockey_power_play",
  },
  {
    title: "4v4",
    id: "roller_hockey_4v4",
  },
  {
    title: "shot",
    id: "roller_hockey_shot",
  },
  {
    title: "save",
    id: "roller_hockey_save",
  },
  {
    title: "other",
    id: "roller_hockey_other",
  },
  {
    title: "substitution",
    id: "roller_hockey_substitution",
  },
];

const handballTags = [
  {
    title: "goal",
    id: "handball_goal",
  },
  {
    title: "shot on goal",
    id: "handball_shot_on_goal",
  },
  {
    title: "save",
    id: "handball_save",
  },
  {
    title: "foul",
    id: "handball_foul",
  },
  {
    title: "red card",
    id: "handball_red_card",
  },
  {
    title: "yellow card",
    id: "handball_yellow_card",
  },
  {
    title: "suspension",
    id: "handball_suspension",
  },
  {
    title: "penalty shot",
    id: "handball_penalty_shot",
  },
  {
    title: "substitution",
    id: "handball_substitution",
  },
];

const wrestlingTags = [
  {
    title: "wow",
    id: "wrestling_wow",
  },
];

const gymnasticTags = [
  {
    title: "wow",
    id: "gymnastic_wow",
  },
];

export const tagsMap = {
  other: otherSportTags,
  general: generalTags,
  basketball: basketballTags,
  soccer: soccerTags,
  americanFootball: footballTags,
  rugby: rugbyTags,
  volleyball: volleyballTags,
  baseball: baseballTags,
  lacrosse: lacrosseTags,
  futsal: futsalTags,
  beachvolleyball: beachVolleyballTags,
  fieldhockey: fieldHockeyTags,
  icehockey: icehockeyTags,
  rollerhockey: rollerHockeyTags,
  handball: handballTags,
  wrestling: wrestlingTags,
  gymnastics: gymnasticTags,
} as Record<TSportType, { title: string; id: string }[]>;
